import * as React from 'react';

import {
  ContextualActionsWrapper as RDCContextualActionsWrapper,
} from '@uncinc/react-drupal-core';
import { IS_CLIENT } from '../../config/constants';

const ContextualActionsWrapper = ({ children }: React.PropsWithChildren<React.ReactNode>) => {
  /**
   * Don't render the ContextualActionsWrapper if the permissions hash is not set.
   * By doing this we prevent an XHR request is made to Drupal to get the permissions
   * for anon users.
   */
  if (IS_CLIENT && sessionStorage.getItem('Drupal.contextual.permissionsHash') === null) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return children;
  }

  return (
    <RDCContextualActionsWrapper>
      {children}
    </RDCContextualActionsWrapper>
  );
};

export default ContextualActionsWrapper;
